import './VideoDuration.scss'

import React, { FC, memo } from 'react'

import { getVideoDuration } from '../utils/misc'

interface Props {
  videoDuration: number | string | undefined
}

const VideoDuration: FC<Props> = ({ videoDuration }) =>
  videoDuration ? <div className="VideoDuration">{`${getVideoDuration(videoDuration)} min`}</div> : null

export default memo(VideoDuration)
